import { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import withImmutablePropsToJS from "with-immutable-props-to-js"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"

import { alignmentTypeSearchConnection } from "shared/stakeholder/selectors"
import { getAlignmentTypes } from "shared/stakeholder/action-creators"

import { parseAndGenerateIssueFilters } from "shared/search/components/FilterableListView/helperFunctions"
import { generateIssueAlignmentFilter } from "shared/search/containers/Filter/Filters"
import { notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

export const createProjectFilterGroup = (uniqueFilterGroupId) => {
    const actions = { getAlignmentTypes }

    class ProjectFilterGroup extends Component {
        render() {
            return genericFilterGroup({
                uniqueFilterGroupId,
                filters: [
                    // inIssueFilter, but with Alignments!
                    generateIssueAlignmentFilter({
                        alignmentTypes: this.props.alignmentTypes,
                        uniqueFilterId: "inIssue",
                        filterKey: "in_issue",
                        displayLabel: "Is in my issues...",
                    }),
                    notInIssueFilter,
                ],
                displayLabel: "Issues",
                helpText: "Filter results by the issue they are tagged to.",
                ...this.props,
            })
        }
    }

    ProjectFilterGroup.propTypes = {
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
    }

    const connectedProjectFilterGroup = connect(
        alignmentTypeSearchConnection,
        actions,
    )(withImmutablePropsToJS(ProjectFilterGroup))

    Object.assign(connectedProjectFilterGroup, {
        defaultProps: {
            filterKeyMap: {
                inIssue: "in_issue",
                notInIssue: "not_in_issue",
            },
            isConnectedFilterGroup: true,
            uniqueFilterGroupId,
            parseFunction: parseAndGenerateIssueFilters,
        },
    })

    return connectedProjectFilterGroup
}
